/**
 * BoxCard: the card that follows a drawn box (Figma 00, 22:119 "New box · what the print says"): the title, the
 * words box, and a row with the box's kind and OK. Shown under the box until OK files it.
 */
import type { ReactNode } from 'react';
import { RADIUS, SPACE, TEXT, WALK, WEIGHT, usePalette } from '../theme';

export function BoxCard({
  title,
  print,
  words,
  kind,
  ok,
}: {
  title: ReactNode;
  /** The settled box's print, enlarged above the words (acceptance 4), or none. */
  print?: ReactNode;
  words: ReactNode;
  kind: ReactNode;
  ok: ReactNode;
}) {
  const p = usePalette();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: SPACE.tight,
        padding: `${SPACE.sm}px ${SPACE.snug}px`,
        borderRadius: RADIUS.button,
        border: `1px solid ${p.hairline}`,
        background: p.surface,
        boxShadow: `0 4px 14px ${p.shadow}`,
        boxSizing: 'border-box',
      }}
    >
      <span style={{ fontSize: TEXT.micro, fontWeight: WEIGHT.strong, color: p.inkMuted, lineHeight: 'normal' }}>{title}</span>
      {print !== undefined && <div role="region" aria-label="Settled box" style={{ maxHeight: WALK.printMax, overflow: 'hidden' }}>{print}</div>}
      {words}
      <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.tight }}>
        {kind}
        {ok}
      </div>
    </div>
  );
}
